import React from 'react';
import * as actionCreators from '../../../store/actions/index';
import { connect } from "react-redux";
import { withRouter } from 'react-router';
import RouteEndPoints from '../../../utilities/RouteEndPoints';

import classes from './ModuleDetailsPage.module.css';
import ShowLoader from '../../../hoc/ShowLoader/ShowLoader';
import ModuleDetailsSidebar from '../../../components/ModuleDetailsSidebar/ModuleDetailsSidebar';

import TechLogo from '../../../assets/icons/Tech-Logos.svg';
import ModulePerformanceTab from '../../../components/ProgramManagerPageSections/ManageProgramsPage/ModulePerformanceTab/ModulePerformanceTab';
import FeedbackTab from '../../../components/ProgramManagerPageSections/ManageProgramsPage/FeedbackTab/FeedbackTab';
import { IsStringEmpty } from '../../../utilities/CommonMethods';
import ModuleScheduleTab from '../../../components/ProgramManagerPageSections/ManageProgramsPage/ModuleScheduleTab/ModuleScheduleTab';
import ModuleAttendanceTab from '../../../components/ProgramManagerPageSections/ManageProgramsPage/ModuleAttendanceTab/ModuleAttendanceTab';
import ModuleCurriculumTab from '../../../components/ProgramManagerPageSections/ManageProgramsPage/ModuleCurriculumTab/ModuleCurriculumTab';
import ClassGrades from '../../../components/ReportsPageTabs/ClassGrades';
import ProgramProgressTopbarPM from '../../../components/ProgramManagerPageSections/ProgramDetailsTopbar/ProgramDetailsTopbar';
import ResourceAPIController from '../../../webServices/ResourceAPIController';

class ModuleDetailsPage extends React.Component {

    state = {
        navigationItems: [
            { id: 0, label: "Performance", value: 'performance' },
            // { id: 1, label: "Curriculum", value: 'curriculum' },
            // { id: 2, label: "Schedule", value: 'schedule' },
            // { id: 3, label: "Evaluation", value: 'evaluation' },
            // { id: 4, label: "Class Grades", value: 'class-grades' },
            // { id: 5, label: "Attendance", value: 'attendance' },
            // { id: 6, label: "Feedback", value: 'feedback' }
        ],
        programType: 'template',
        activeNavigationItem: -1,
        showContentLoader: false,
        batchCode: 'FSR160421',
        moduleName: 'Javascript',
        moduleLogo: '',
        show: true,
        modulesList: [
        ],
        hideSidebar: false,
        programDetails: {
            name: '',
            progress: 0,
            batchCode: '',
            moduleName: 'Loading...',
            moduleProgress: 0
        },
        showProgramDetailsTopbar: true
    }

    onNavigationItemClick = (pos) => {
        if (pos !== this.state.activeNavigationItem) {
            const activePageType = this.state.navigationItems[pos].value,
                batchCode = this.props.match.params.batchCode,
                moduleName = this.props.match.params.moduleName;

            this.props.history.push(RouteEndPoints.PROGRAMS_PAGE + '/' + batchCode + '/modules/' + encodeURIComponent(moduleName) + '/' + activePageType);

            const sidebarShow = pos === 2 ? false : true;

            this.setState({ activeNavigationItem: pos, showContentLoader: false, show: sidebarShow });
        }
    }

    getModulePerformanceData = (batchCode, moduleName) => {
        this.setState({ showContentLoader: true });
        let responseObj = null;
        ResourceAPIController.getModulePerformanceData(batchCode, moduleName)
            .then(response => {
                responseObj = response.result;
                // console.log('get Module Performance Data - response => ', response.result);

                const updatedNavigationItems = responseObj.programType !== 'template'
                    ? [
                        { id: 0, label: "Performance", value: 'performance' },
                        { id: 1, label: "Curriculum", value: 'curriculum' },
                        { id: 2, label: "Schedule", value: 'schedule' },
                        { id: 3, label: "Evaluation", value: 'evaluation' },
                        { id: 4, label: "Class Grades", value: 'class-grades' },
                        { id: 5, label: "Attendance", value: 'attendance' },
                        { id: 6, label: "Feedback", value: 'feedback' }
                    ]
                    : [
                        { id: 0, label: "Schedule", value: 'schedule' },
                        { id: 1, label: "Curriculum", value: 'curriculum' }
                    ]
                // alert(responseObj.programType)
                this.setState({
                    showContentLoader: false,
                    moduleLogo: responseObj.moduleLogo,
                    programType: responseObj.programType,
                    navigationItems: updatedNavigationItems
                });

                this.getModuleDetailsPageData();
                this.setModuleProgress(responseObj.moduleProgress);
            })
            .catch(err => {
                this.setState({ showContentLoader: false });
                console.log(err)
                if (err.error.status === 401) {
                    if (err.error.message === 'Invalid token.') {
                        this.props.showSessionExpiredDialog(true);
                    } else {
                        this.props.redirectToUnauthorized();
                    }
                } else {
                    this.props.onFailureDialogShow(err.error.message, 'OKAY');
                }
            });
    }

    setModuleProgress = (progress) => {
        let updatedData = { ...this.state.programDetails };
        updatedData.moduleProgress = progress;
        this.setState({ programDetails: updatedData });
    }

    handleShowHide = (val) => {
        this.setState({ show: !val });
    }

    handleSideBar = (val) => {
        if (val) {
            this.setState({
                hideSideBar: false,
                showProgramDetailsTopbar: val
            })
            this.props.setupProgramDetailsTopbar(true, true, true, true);
        }
        else if (!val) {
            this.setState({
                hideSideBar: true,
                showProgramDetailsTopbar: val
            })
            this.props.setupProgramDetailsTopbar(false, true, true, true);
        }
    }

    getModuleDetailsPageData = () => {
        const activeTab = this.props.match.params.activeTab;
        if (!IsStringEmpty(activeTab)) {
            const activeItemPos = this.state.navigationItems.findIndex(navItem => navItem.value === activeTab);
            if (activeItemPos !== -1) {
                this.onNavigationItemClick(activeItemPos);
            } else {
                this.onNavigationItemClick(0);
            }
        } else {
            this.onNavigationItemClick(0);
        }

    }

    setNewURL = (feedbackType, feedbackId) => {
        // '/:batchCode/modules/:moduleName/:activeTab?'
        const batchCode = this.props.match.params.batchCode,
            moduleName = this.props.match.params.moduleName;

        if (!IsStringEmpty(feedbackId)) {
            this.props.history.push(RouteEndPoints.PROGRAMS_PAGE + '/' + batchCode + '/modules/' + encodeURIComponent(moduleName) + '/feedback/' + feedbackType + '/' + feedbackId);
        } else if (feedbackId === '') {
            this.props.history.push(RouteEndPoints.PROGRAMS_PAGE + '/' + batchCode + '/modules/' + encodeURIComponent(moduleName) + '/feedback/' + feedbackType);
        }
    }

    componentDidMount() {
        this.props.setupProgramDetailsTopbar(true, true, true, true);

        const updatedData = { ...this.state.programDetails };
        updatedData.batchCode = this.props.match.params.batchCode;
        updatedData.moduleName = this.props.match.params.moduleName
        this.setState({
            batchCode: this.props.match.params.batchCode,
            moduleName: this.props.match.params.moduleName,
            programDetails: updatedData
        });
        if (!IsStringEmpty(this.props.match.params.batchCode) && !IsStringEmpty(this.props.match.params.moduleName)) {
            this.getModulePerformanceData(this.props.match.params.batchCode, this.props.match.params.moduleName);
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.location.pathname !== this.props.location.pathname) {
            this.getModuleDetailsPageData();
        }
    }

    render() {
        let renderData = null;
        switch (this.state.activeNavigationItem) {
            case 0: renderData = this.state.programType === 'template'
                ? <ModuleScheduleTab
                    fullWidth={!this.state.show}
                    params={this.props.match.params}
                    activeProgramBatchCode={this.props.match.params.batchCode}
                    activeModuleName={this.props.match.params.moduleName}
                    onFailureDialogShow={this.props.onFailureDialogShow}
                    redirectToUnauthorized={this.props.redirectToUnauthorized}
                    showSessionExpiredDialog={this.props.showSessionExpiredDialog}
                    redirectToNotFound={this.props.redirectToNotFound}
                    redirectToServerError={this.props.redirectToServerError} />
                : <ModulePerformanceTab
                    setModuleProgress={this.setModuleProgress}
                    onViewAllClassGradesClicked={this.onNavigationItemClick}
                    batchCode={this.props.match.params.batchCode}
                    moduleName={this.props.match.params.moduleName}
                    viewAllFeedbacksClick={this.onNavigationItemClick}
                    params={this.props.match.params}
                    onFailureDialogShow={this.props.onFailureDialogShow}
                    redirectToUnauthorized={this.props.redirectToUnauthorized}
                    showSessionExpiredDialog={this.props.showSessionExpiredDialog}
                    redirectToNotFound={this.props.redirectToNotFound}
                    redirectToServerError={this.props.redirectToServerError}
                />; break;
            case 1: renderData = this.state.programType === 'template'
                ? <ModuleCurriculumTab
                    params={this.props.match.params}
                    activeProgramBatchCode={this.props.match.params.batchCode}
                    activeModuleName={this.props.match.params.moduleName}
                    onFailureDialogShow={this.props.onFailureDialogShow}
                    redirectToUnauthorized={this.props.redirectToUnauthorized}
                    showSessionExpiredDialog={this.props.showSessionExpiredDialog}
                    redirectToNotFound={this.props.redirectToNotFound}
                    redirectToServerError={this.props.redirectToServerError} />
                : <ModuleCurriculumTab
                    params={this.props.match.params}
                    activeProgramBatchCode={this.props.match.params.batchCode}
                    activeModuleName={this.props.match.params.moduleName}
                    onFailureDialogShow={this.props.onFailureDialogShow}
                    redirectToUnauthorized={this.props.redirectToUnauthorized}
                    showSessionExpiredDialog={this.props.showSessionExpiredDialog}
                    redirectToNotFound={this.props.redirectToNotFound}
                    redirectToServerError={this.props.redirectToServerError} />; break;
            case 2: renderData = <ModuleScheduleTab
                fullWidth={!this.state.show}
                params={this.props.match.params}
                activeProgramBatchCode={this.props.match.params.batchCode}
                activeModuleName={this.props.match.params.moduleName}
                onFailureDialogShow={this.props.onFailureDialogShow}
                redirectToUnauthorized={this.props.redirectToUnauthorized}
                showSessionExpiredDialog={this.props.showSessionExpiredDialog}
                redirectToNotFound={this.props.redirectToNotFound}
                redirectToServerError={this.props.redirectToServerError} />;
                break;

            case 3: renderData = <h1>Evaluation Tab </h1>; // We are redirecting to Newly created Evaluation Page
                break;

            case 4: renderData = <ClassGrades
                handleSideBar={this.handleSideBar}
                isProgramManager={true} params={this.props.match.params}
                batchCode={this.props.match.params.batchCode}
                moduleName={this.props.match.params.moduleName}
                onFailureDialogShow={this.props.onFailureDialogShow}
                redirectToUnauthorized={this.props.redirectToUnauthorized}
                showSessionExpiredDialog={this.props.showSessionExpiredDialog}
                redirectToNotFound={this.props.redirectToNotFound}
                redirectToServerError={this.props.redirectToServerError} />;
                break;

            case 5: renderData = <ModuleAttendanceTab
                handleShowHide={this.handleSideBar}
                viewAll={!this.state.show}
                isProgramManager={true}
                batchCode={this.props.match.params.batchCode}
                moduleName={this.props.match.params.moduleName}
                onFailureDialogShow={this.props.onFailureDialogShow}
                redirectToUnauthorized={this.props.redirectToUnauthorized}
                showSessionExpiredDialog={this.props.showSessionExpiredDialog}
                redirectToNotFound={this.props.redirectToNotFound}
                redirectToServerError={this.props.redirectToServerError} />;
                break;

            case 6: renderData = <FeedbackTab
                params={this.props.match.params}
                pathname={this.props.location.pathname}
                setNewURL={this.setNewURL}
                activeProgramBatchCode={this.props.match.params.batchCode}
                activeModuleName={this.props.match.params.moduleName}
                onFailureDialogShow={this.props.onFailureDialogShow}
                redirectToUnauthorized={this.props.redirectToUnauthorized}
                showSessionExpiredDialog={this.props.showSessionExpiredDialog}
                redirectToNotFound={this.props.redirectToNotFound}
                redirectToServerError={this.props.redirectToServerError}
            />; break;

            default: renderData = <div className={classes.LoaderContainer}>
                <ShowLoader isLoading={true} />
            </div>; break;
        }

        return (
            <div className={[classes.ModuleDetailsPage,
            this.state.hideSideBar && classes.FullScreen,
            !this.state.show ? classes.FullWidth : '',
            ((this.state.programType === 'template' && this.state.activeNavigationItem === 0) || (this.state.activeNavigationItem === 2)) ? classes.FullPageWidth : ''].join(' ')}>
                {
                    this.state.showProgramDetailsTopbar
                        ? <ProgramProgressTopbarPM
                            batchCode={this.state.batchCode}
                            name={this.state.programDetails.moduleName}
                            // progress={this.state.programDetails.moduleProgress} 
                            progress={0}
                            hideProgress={true} />
                        : null
                }

                {!this.state.hideSideBar && <ModuleDetailsSidebar
                    forOverviewPage={true}
                    heading={this.state.moduleName}
                    breadCrumb={this.state.batchCode}
                    logo={this.state.moduleLogo}
                    navigationItems={this.state.navigationItems}
                    onNavigationItemClick={this.onNavigationItemClick}
                    activeType={this.state.activeNavigationItem}
                    onBreadCrumbClick={this.onBreadCrumbClick}
                    enrolledPrograms={this.state.enrolledPrograms}
                    handleShowHide={this.handleShowHide}
                    show={this.state.show}
                    solidBackground={(this.state.programType === 'template' && this.state.activeNavigationItem === 0) || (this.state.activeNavigationItem === 2)} />}
                {
                    this.state.showContentLoader
                        ? <div className={classes.LoaderContainer}>
                            <ShowLoader isLoading={true} />
                        </div>
                        : renderData
                }

            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        showSuccessDialog: state.showSuccessDialog,
        successDialogMessage: state.successDialogMessage,
        successDialogButtonLabel: state.successDialogButtonLabel,
        showFailureDialog: state.showFailureDialog,
        failureDialogMessage: state.failureDialogMessage,
        failureDialogButtonLabel: state.failureDialogButtonLabel,
        somethingWentWrong: state.somethingWentWrong,
        notFound: state.notFound,
        unauthorized: state.unauthorized,
    }
}

const mapDisptachToProps = dispatch => {
    return {
        setupProgramDetailsTopbar: (showTopbar, showProgramProgress, showModuleProgress, hideTopbar) => dispatch(actionCreators.setupProgramDetailsTopbar(showTopbar, showProgramProgress, showModuleProgress, hideTopbar)),

        onFailureDialogShow: (msg, btnLabel) => dispatch(actionCreators.onFailureDialogShow(msg, btnLabel)),
        onFailureDialogHide: () => dispatch(actionCreators.onFailureDialogHide()),
        onSuccessDialogShow: (msg, btnLabel) => dispatch(actionCreators.onSuccessDialogShow(msg, btnLabel)),
        onSuccessDialogHide: () => dispatch(actionCreators.onSuccessDialogHide()),

        redirectToUnauthorized: () => dispatch(actionCreators.redirectToUnauthorized()),
        redirectToNotFound: () => dispatch(actionCreators.redirectToNotFound()),
        redirectToServerError: () => dispatch(actionCreators.redirectToServerError()),
        showSessionExpiredDialog: (show) => dispatch(actionCreators.showSessionExpiredDialog(show))

    }
}

export default connect(mapStateToProps, mapDisptachToProps)(withRouter(ModuleDetailsPage));